<arsultima-loader
  *ngIf="loading; else upload"
  [loading]="loading"
  style="height: 200px;"
></arsultima-loader>

<ng-template #upload>
  <div>
    <!-- Image viewer and link to the slideshow -->
    <ng-container *ngIf="imageUrl; else defaultImg">
      <img
        [src]="imageUrlWithRefresh"
        class="slide-image c-pointer"
        (click)="clickZoomImage()"
        #image
      />
    </ng-container>

    <!-- Default image -->
    <ng-template #defaultImg>
      <div class="image-placeholder d-flex align-items-center justify-content-center">
        <i class="material-icons">photo_library</i>
      </div>
    </ng-template>

    <!-- File uploader -->
    <div class="d-flex col-xs-12 m-t-xs button-container">
      <input
        type="file"
        accept="image/*,application/pdf"
        class="d-none"
        #fileUpload
        (change)="fileChange(fileUpload.files)"
      />
      <ng-container *ngIf="!fileName; else btnContainer">
        <button
          type="button"
          mat-flat-button
          color="primary"
          [disabled]="disabled"
          (click)="fileUpload.click()"
        >
          {{ buttonLabel }}
        </button>
      </ng-container>
      <ng-template #btnContainer>
        <button
          type="button"
          mat-icon-button
          [disabled]="disabled"
          matTooltip="{{ 'buttons.edit' | transloco }}"
          (click)="fileUpload.click()"
        >
          <mat-icon class="icon-small">edit</mat-icon>
        </button>
        <button
          type="button"
          mat-icon-button
          [disabled]="disabled"
          matTooltip="{{ 'buttons.delete' | transloco }}"
          (click)="deleteFile()"
        >
          <mat-icon class="icon-small">delete</mat-icon>
        </button>
        <button
          type="button"
          mat-icon-button
          matTooltip="{{ 'buttons.rotate' | transloco }}"
          (click)="rotate()"
          *ngIf="showRotate"
        >
          <mat-icon class="icon-small">rotate_left</mat-icon>
        </button>
        <div class="align-self-center m-l-md">{{ fileName }}</div>
      </ng-template>
    </div>
  </div>
</ng-template>
